import React from "react";
import {Button} from "flowbite-react";
import tenkenTheme from "../../configs/themes/tenkenTheme";

const ButtonLink = (props) => {
    const navigate = () => {
        window.location.href = props.href;
    };

    const defaultClass = 'border text-center rounded-[20px] xl:h-[39px] md:h-[35px] xl:w-[110px] md:w-[100px]';
    const typeClasses = {
        default: "bg-white text-tenken-gray-900 border-[#9e9e9e] hover:bg-tenken-gray-100",
        primary: "bg-[#2e90fa] text-white hover:bg-[#2374fd]",
    };

    const tmpProps = {
        ...props,
        theme: tenkenTheme.button,
        color: "primary",
        className: `${defaultClass} ${typeClasses[props.type]} ${props.className}`,
        onClick: (e) => navigate(e)
    };

    return (
        <Button {...tmpProps}>
            {props.children}
        </Button>
    );
};

export default ButtonLink;